import { Box, CircularProgress } from "@material-ui/core";
import { useState } from "react";
import CssPagination from "src/components/Pagination/CssPagination";
import Empty from "src/components/utils/Empty";
import { FS } from "src/config/constants";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import usePagination from "src/hooks/usePagination";
import AssetHeader from "./AssetHeader";
import AssetRow from "./AssetRow";
import MobileDetailAsset from "./MobileDetailAsset";

export default function AssetList({ tokenList }) {
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [isDetail, setIsDetail] = useState(false);
  const { fetchingDataStatus } = usePoolMonitoringContext();
  const { data, jump, maxPage, currentPage } = usePagination(tokenList);

  return isDetail ? (
    <MobileDetailAsset asset={selectedAsset} setIsDetail={setIsDetail} />
  ) : (
    <Box>
      <AssetHeader />
      {data?.map((asset, index) => {
        return <AssetRow key={index} asset={asset} setSelectedAsset={setSelectedAsset} setIsDetail={setIsDetail} />;
      })}
      {data.length == 0 && (
        <Box display="flex" justifyContent="center">
          <Empty title="No data" iconProps={{ style: { fontSize: "5rem" } }} />
        </Box>
      )}
      {fetchingDataStatus === FS.INITIAL ||
        (fetchingDataStatus === FS.FETCHING && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        ))}
      {tokenList.length > 0 && (
        <CssPagination
          mt={1}
          paginationProps={{ page: currentPage, count: maxPage, onChange: (_, page) => jump(page) }}
        />
      )}
    </Box>
  );
}
